import PropTypes from "prop-types";
import { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";

import { strCode } from "../../../consts";
import { t } from "../../../services";
import { useGroupsData } from "../../../hooks";

import {
  FlexContainers,
  Heading5,
  Modal,
  SmallButton,
  WrapperContainer
} from "../../../components";
import GroupsTable from "../../Groups/GroupsTable";
import useDeepCompareEffect from "use-deep-compare-effect";

const UserGroupsModal = ({ isActive, setActive, onSubmit }) => {
  const groups = useSelector((store) => store.userGroups?.groups);
  const loading = useSelector((store) => store.userGroups?.loading);

  const {
    groupsData,
    editingGroup,
    setEditingGroup,
    onAddGroup,
    onEditSave,
    onEditCancel,
    onDelete,
    resetData
  } = useGroupsData(groups);

  useEffect(() => {
    if (!isActive) {
      resetData();
    }
  }, [isActive]);

  useDeepCompareEffect(() => {
    resetData();
  }, [groups]);

  const handleSubmit = useCallback(async () => {
    await onSubmit(groupsData);

    setActive(false);
  });

  return (
    <Modal
      id="group-settings-modal"
      active={isActive}
      setActive={setActive}
      closable={false}
      modalHeader={<Heading5>{t(strCode.GROUP_SETTINGS_TITLE)}</Heading5>}
      modalFooter={
        <WrapperContainer Container={FlexContainers.FlexRowEnd} gap={8} width={"100%"}>
          <SmallButton secondary onClick={() => setActive(false)} disabled={loading}>
            {t(strCode.DISCARD_BTN)}
          </SmallButton>

          <SmallButton
            onClick={() => handleSubmit(groupsData)}
            disabled={loading}
            loading={loading}>
            {t(strCode.SUBMIT_BTN)}
          </SmallButton>
        </WrapperContainer>
      }>
      <WrapperContainer Container={FlexContainers.FlexColumnStart} width={720}>
        <GroupsTable
          groups={groupsData}
          editingGroup={editingGroup}
          setEditingGroup={setEditingGroup}
          onAdd={onAddGroup}
          onEditSave={onEditSave}
          onEditCancel={onEditCancel}
          onDelete={onDelete}
        />
      </WrapperContainer>
    </Modal>
  );
};

UserGroupsModal.propTypes = {
  isActive: PropTypes.bool,
  setActive: PropTypes.func,
  onSubmit: PropTypes.func
};

export default UserGroupsModal;
